// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/ExpenseClaimHeader.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claim Header
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";


import {
  getAssignableBusinessPartners,
} from "../../../pms/services/businessPartnerService";

import expenseMasterService from "../services/expenseMasterService";

import expenseClaimService  from "../services/expenseClaimService";
export default function ExpenseClaimHeader({

  data = {},

  onChange,

  readOnly = false,

}) {

    

    // ==========================================================
    // STATE
    // ==========================================================

    const [bpList, setBpList] =     useState([]);

    const [  expensePolicies,  setExpensePolicies,] = useState([]);

    const [  currencies,  setCurrencies,] = useState([]);

    // ==========================================================
    // LOAD
    // ==========================================================

    useEffect(() => {

    loadBusinessPartners();

     loadExpensePolicies();

    }, []);

    async function loadCurrencies() {

  try {

    const response =
      await expenseClaimService.getCurrencies();

    setCurrencies(response);

  }

  catch (error) {

    console.error(

      "Failed to load Currencies",

      error

    );

  }

}
    
    
    // ==========================================================
    // LOAD BUSINESS PARTNERS
    // ==========================================================

    async function loadBusinessPartners() {

    try {

        const res =
        await getAssignableBusinessPartners();

        const serviceProviders =

        (res.data.data || [])

        .filter(

            bp =>
            bp.role ===
            "SERVICE_PROVIDER"

        );

        setBpList(
        serviceProviders
        );

    }

    catch (err) {

        console.error(

        "Failed to load Service Providers",

        err

        );

    }

    }
    // ==========================================================
  // UPDATE FIELD
  // ==========================================================

  function update(field, value) {

    let updatedData = {

        ...data,

        [field]: value,

    };

    // ==========================================================
    // EMPLOYEE CHANGED
    // ==========================================================

    if (

        field === "employee_id" &&

        value !== data.employee_id

    ) {

        updatedData = {

            ...updatedData,

            expense_source: "",
            reference_module: "",
            reference_type: "",

            reference_id: null,
            reference_number: "",

            service_ticket_id: null,
            service_visit_id: null,

            customer_id: null,
            installed_product_id: null,

            customer_name: "",
            contact_person: "",
            contact_number: "",

            engineer_name: "",
            assigned_engineer: "",

            ticket_no: "",
            visit_no: "",

            priority: "",
            category: "",
            status: "",
            visit_status: "",

            instance_id: "",
            engine_serial_no: "",

            visit_datetime: "",
            visit_start_time: "",
            visit_end_time: "",
            visit_duration_minutes: null,

            running_hours: "",

            start_address: "",
            end_address: "",

            work_done: "",
            observations: "",
            parts_used: "",
            resolution_summary: "",

        };

    }

    onChange?.(
        updatedData
    );

}
  // ==========================================================
// LOAD EXPENSE POLICIES
// ==========================================================

useEffect(() => {

  loadExpensePolicies();
   loadCurrencies();

}, []);

async function loadExpensePolicies() {

  try {

    const response =
      await expenseClaimService.getExpensePolicies();

    setExpensePolicies(response);

  }

  catch (error) {

    console.error(

      "Failed to load Expense Policies",

      error

    );

  }

}

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div className="card shadow-sm mb-4">

      <div className="card-header">

        <h5 className="mb-0">

          Expense Claim Information

        </h5>

      </div>

      <div className="card-body">

        <div className="row g-3">

          {/* ====================================================== */}
          {/* EMPLOYEE */}
          {/* ====================================================== */}

          <div className="col-md-3">

            <label className="form-label">

              Employee
              <span className="text-danger">
                *
              </span>

            </label>

            <select
                className="form-select"
                disabled={readOnly}
                value={data.employee_id || ""}
                onChange={(e) =>
                    update(
                    "employee_id",
                    e.target.value
                    )
                }
                >

                <option value="">
                    Select Employee
                </option>

                {bpList.map((bp) => (

                    <option
                    key={bp.id}
                    value={bp.id}
                    >

                    {bp.name}
                    {" "}
                    ({bp.role})

                    </option>

                ))}

                </select>

          </div>

          {/* ====================================================== */}
          {/* EXPENSE POLICY */}
          {/* ====================================================== */}

          <div className="col-md-3">

            <label className="form-label">

              Expense Policy
              <span className="text-danger">
                *
              </span>

            </label>

            <select
                className="form-select"
                disabled={readOnly}
                value={
                    data.expense_policy_id || ""
                }
                onChange={(e) =>
                    update(
                    "expense_policy_id",
                    e.target.value
                    )
                }
                >

                <option value="">
                    Select Policy
                    </option>

                    {expensePolicies.map((policy) => (

                          <option
                              key={policy.expense_policy_id}
                              value={policy.expense_policy_id}
                          >

                              {policy.name || policy.policy_name}

                          </option>

                      ))}

                </select>

          </div>

          {/* ====================================================== */}
          {/* CLAIM DATE */}
          {/* ====================================================== */}

          <div className="col-md-3">

            <label className="form-label">

              Claim Date
              <span className="text-danger">
                *
              </span>

            </label>

            <input
              type="date"
              disabled={readOnly}
              className="form-control"
              value={
                data.claim_date || ""
              }
              onChange={(e) =>
                update(
                  "claim_date",
                  e.target.value
                )
              }
            />

          </div>

          {/* ====================================================== */}
          {/* CURRENCY */}
          {/* ====================================================== */}

          <div className="col-md-3">

            <label className="form-label">

              Currency
              <span className="text-danger">
                *
              </span>

            </label>

            <select
              className="form-select"
              disabled={readOnly}
              value={
                data.currency_id || ""
              }
              onChange={(e) =>
                update(
                  "currency_id",
                  e.target.value
                )
              }
            >

              <option value="">
                Select Currency
              </option>

              {currencies.map((currency) => (

                <option
                  key={currency.currency_id}
                  value={currency.currency_id}
                >

                  {currency.code} - {currency.name}

                </option>

              ))}

            </select>

          </div>

          {/* ====================================================== */}
          {/* TITLE */}
          {/* ====================================================== */}

          <div className="col-md-6">

            <label className="form-label">

              Claim Title

            </label>

            <input
              className="form-control"
              disabled={readOnly}
              placeholder="Enter Claim Title"
              value={
                data.title || ""
              }
              onChange={(e) =>
                update(
                  "title",
                  e.target.value
                )
              }
            />

          </div>

          {/* ====================================================== */}
          {/* PURPOSE */}
          {/* ====================================================== */}

          <div className="col-md-6">

            <label className="form-label">

              Purpose

            </label>

            <textarea
              rows="2"
              className="form-control"
              disabled={readOnly}
              placeholder="Enter Purpose"
              value={
                data.purpose || ""
              }
              onChange={(e) =>
                update(
                  "purpose",
                  e.target.value
                )
              }
            />

          </div>

        </div>

      </div>

    </div>

  );

}